const About = () => {
  return (
    <section id="sobre" className="py-20 bg-gradient-to-b from-[#0a1628] to-[#0078c9] relative overflow-hidden">
      {/* Subtle brand accent glow */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#0877c5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#b51625]/8 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-white">
                Sobre a Art Custom
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Especialistas em uniformes para marcas e empresas que exigem qualidade e pontualidade.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <p className="text-lg text-gray-300 leading-relaxed">
                  A <span className="font-bold text-[#4da8e8]">Art Custom</span> nasceu com o propósito de
                   inovar e oferecer soluções exclusivas para destacar a imagem do seu negócio através do 
                   vestuário e uniformes.     
                </p>
                <p className="text-lg text-gray-300 leading-relaxed">
                Com uma gama de técnicas de estampagem que unem alta durabilidade e efeitos de destaque como alto relevo, 
                foil e efeitos especiais, garantimos que cada peça seja um reflexo único do negócio. 
                Unindo paixão e profissionalismo, do início a entrega, cuidamos de cada detalhe para produzir com qualidade 
                dentro do melhor prazo do Brasil.
                </p>
                <div className="flex flex-wrap gap-4 pt-4">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-[#0877c5] rounded-full"></div>
                    <span className="text-gray-300">Design Personalizado</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-[#b51625] rounded-full"></div>
                    <span className="text-gray-300">Alta Qualidade</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-[#f3eb03] rounded-full"></div>
                    <span className="text-gray-300">Entrega Rápida</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 shadow-2xl">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors group">
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#0877c5]/25 to-[#0877c5]/5 ring-1 ring-[#0877c5]/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                      <svg className="w-5 h-5 text-[#4da8e8]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" /></svg>
                    </div>
                    <h3 className="font-bold text-white mb-2">Uniforme</h3>
                    <p className="text-sm text-gray-400">Para sua equipe.</p>
                  </div>
                  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors group">
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#b51625]/25 to-[#b51625]/5 ring-1 ring-[#b51625]/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                      <svg className="w-5 h-5 text-[#e84860]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42" /></svg>
                    </div>
                    <h3 className="font-bold text-white mb-2">Técnicas de estampagem</h3>
                    <p className="text-sm text-gray-400">Relevo, foil e efeitos de destaque.</p>
                  </div>
                  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors group">
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#f3eb03]/25 to-[#f3eb03]/5 ring-1 ring-[#f3eb03]/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                      <svg className="w-5 h-5 text-[#f3eb03]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" /></svg>
                    </div>
                    <h3 className="font-bold text-white mb-2">Atendimento consultivo</h3>
                    <p className="text-sm text-gray-400">Entender sua necessidade e indicar a melhor solução.</p>
                  </div>
                  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors group">
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#4da8e8]/25 to-[#4da8e8]/5 ring-1 ring-[#4da8e8]/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                      <svg className="w-5 h-5 text-[#4da8e8]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
                    </div>
                    <h3 className="font-bold text-white mb-2">Compromisso com prazos</h3>
                    <p className="text-sm text-gray-400">Processo organizados e entregas dentro do melhor prazo do Brasil.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
